import { Skeleton } from '@mui/material'
import { useRef } from 'react'
import { Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom'

import { useGetByTenantAccountAndAccountSourceAccountIdentifierQuery } from '@/api'
import {
  GenericErrorBoundary,
  Icon,
  LeftSideBar,
  Link,
  Navigation,
  UserMenuTopBar
} from '@/components/core-v2'
import { PATH, TENANT } from '@/const'

import { ReportingTradeClosePage } from '../trade-close'
import { ReportingTradeDetailsPage } from '../trade-details'
import { ReportingTradeEventsPage } from '../trade-events'
import { ReportingTradeFeesPage } from '../trade-fees'
import { ReportingTradeHistoryAndDocumentsPage } from '../trade-history-and-documents'
import { ReportingTradePerformancePage } from '../trade-performance'
import { ReportingTradeRiskPage } from '../trade-risk'
import classes from './index.module.scss'

const BackToTradeList = () => {
  const { source, tradeId } = useParams()
  const { data, isLoading } = useGetByTenantAccountAndAccountSourceAccountIdentifierQuery({
    tenant: TENANT,
    accountIdentifier: tradeId,
    accountSource: source
  })
  const { state } = useLocation()
  const locationState = useRef(state)

  if (isLoading) return <Skeleton height="28px" width="200px" />

  return (
    <div className={classes.backToTradeList}>
      <Link state={locationState.current} to={PATH.reportsTrades}>
        <Icon name="chevronLeft" />
        Back to trade list
      </Link>
      <span>{data.account?.accountName}</span>
    </div>
  )
}

export const ReportingTrade = () => {
  const { source, tradeId } = useParams()

  return (
    <GenericErrorBoundary>
      <LeftSideBar
        leftElement={<Navigation />}
        mainElement={
          <GenericErrorBoundary>
            <Routes>
              <Route
                element={<Navigate to={PATH.reportsSingleTradePerformance(source, tradeId)} />}
                path=""
              />
              <Route element={<ReportingTradePerformancePage />} path="performance" />
              <Route element={<ReportingTradeEventsPage />} path="events/:date/*" />
              <Route element={<ReportingTradeDetailsPage />} path="details/*" />
              <Route element={<ReportingTradeFeesPage />} path="fees/*" />
              <Route element={<ReportingTradeHistoryAndDocumentsPage />} path="history-documents" />
              <Route element={<ReportingTradeRiskPage />} path="trade-risk/*" />
              <Route element={<ReportingTradeClosePage />} path="close" />
            </Routes>
          </GenericErrorBoundary>
        }
        topBarElement={<UserMenuTopBar leftElement={<BackToTradeList />} />}
      />
    </GenericErrorBoundary>
  )
}
